/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PraticaEditSessionSnapshotDTO { 
    has_editor?: boolean;
    editor_name?: string;
    viewers_count?: number;
}

